module.exports = __webpack_public_path__ + "128ebce559c3a2081037a235c4854fb1.svg";